const numberFormatter = new Intl.NumberFormat('de-CH', {
  style: 'decimal',
  currency: 'CHF',
  minimumFractionDigits: 2,
})

export default {
  path: '/abschluss',
  name: 'abschluss',
  component: () => import('./StepAbschluss.vue'),
  children: [
    {
      path: 'veroeffentlichen',
      component: () => import('./Dialogs/DialogVeroeffentlichen.vue'),
    },
  ],
  meta: {
    step: {
      label: 'Bestätigung & Abschluss',
      sublabel: options => 'Für CHF ' + numberFormatter.format(options.price),
      showInHeader: true,
      isActive: (store, requestMetaStore) => !requestMetaStore.finalized,
      requiresEnterValidation: true,
      allowSave: false,
      get store() {
        return useStepStore('abschluss')
      },
    },
  },
} as const satisfies OwnbitConfigurator.Steps.Route<'abschluss'>
